<template>
  <div class="setting-bg">
    <SettingOption :titles="titles" @onClick="onClickTitle"></SettingOption>
    <div class="options-content">
      <component v-bind:is="currentComponent" class="contents"></component>
    </div>
  </div>
</template>

<script>
import SettingOption from "./SettingOption.vue";
import AdsView from "./component/AdsView.vue";
import BasicView from "./component/BasicView.vue";
import FunctionView from "./component/FunctionView.vue";
import MenuView from "./component/MenuView.vue";
import Permission from "./component/Permission.vue";
import TemplateView from "./component/TemplateView.vue";
import BgmView from "./component/BgmView.vue";
import MaskView from "./component/MaskView.vue";
import SpeechExplainView from "./component/SpeechExplainView.vue";
import StartAnimation from "./component/StartAnimation.vue";
import {mapState} from "vuex";
export default {
  components: {
    SettingOption,
    AdsView,
    BasicView,
    FunctionView,
    MenuView,
    Permission,
    TemplateView,
    BgmView,
    MaskView,
    SpeechExplainView,
    StartAnimation
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    })
  },
  data() {
    return {
      titles: [
        { title: this.$t('moduleTitles.basicInfo'), component: "BasicView" },
        { title: this.$t('edit.editActionTitles.adsSets'), component: "AdsView" },
        { title: this.$t('edit.editActionTitles.menuSets'), component: "MenuView" },
        // { title: "界面模板", component: "TemplateView" },
        { title: this.$t('edit.editActionTitles.pwdSets'), component: "Permission" },
        { title: this.$t('edit.editActionTitles.senceMaskSets'), component: "MaskView" },
        { title: this.$t('descriptions.bgm'), component: "BgmView" },
        { title: this.$t('edit.editActionTitles.speechExplainSets'), component: "SpeechExplainView" },
        { title: this.$t('edit.editActionTitles.funcSets'), component: "FunctionView" },
        { title: this.$t('edit.editActionTitles.startAnimation'), component: "StartAnimation" },
      ],
      currentComponent: "BasicView",
    };
  },
  mounted() {
    /*if(this.userInfo.level == 0){
      const index = this.titles.findIndex(obj=> obj.component == 'MenuView')
      this.titles.splice(index,1)
    }*/
  },
  methods: {
    onClickTitle(item) {
      this.currentComponent = item.component;
    },
  },
};
</script>

<style scoped>
.setting-bg {
  width: calc(100% - 90px);
  height: 100%;
  display: flex;
  left: 90px;
  position: absolute;
  z-index: 110;
}
.options-content {
  width: calc(100% - 88px);
  height: 100%;
  overflow: auto;
  background-color: #ffffff;
}
  .options-content > .contents{
    height: 100%;
  }
</style>
